import post from '../../../axios/post'
import stat from '../../../shared/constant'

const login = {
  postLogin: async (data) => {
    const response = await post.AxiosPostLogin(stat.URL_LOGIN, data)
    return response
  }
}

export default login
